
<ul class="klk_week_list">
  <li class="week_wrapper" v-for="(item, i) in week_list" :key="i">
    <label>
      <input :key="item.id" :value="item.id" type="checkbox" v-model="days" />
      <span>{{ item.name }}</span>
    </label>
  </li>
</ul>
